import React, { useCallback, useEffect, useState } from "react";
import { Form, Input, message, Modal, Row, Select, Typography } from "antd";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { NewProductAttribute, ProductsRepository } from "../../../../../domain";
import { useAppSelector } from "../../../../../application/store";

const { useForm, Item } = Form;

type EditAttributeModalProps = {
  visible: boolean;
  onClose: (refresh: boolean) => void;
  attribute?: NewProductAttribute;
};

const EditAttributeModal: React.FC<EditAttributeModalProps> = ({
  visible,
  onClose,
  attribute,
}) => {
  const [form] = useForm();
  const { colors } = useAppSelector((state) => state.colors);
  const [colorId, setColorId] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  const stableSetFields = useCallback(form.setFields, []);
  useEffect(() => {
    stableSetFields([
      { name: "color", value: attribute?.color.id },
      { name: "count", value: attribute?.count },
      { name: "price", value: attribute?.price },
      { name: "size", value: attribute?.size },
      { name: "sizeDescription", value: attribute?.sizeDescription },
      { name: "offPrice", value: attribute?.offPrice },
    ]);
  }, [attribute, stableSetFields]);

  const submit = async () => {
    try {
      console.log(form.getFieldValue("color"));

      await form.validateFields();
      if (attribute === undefined || attribute.id === undefined) return;
      setIsLoading(true);
      const res = await ServiceLocater.get<ProductsRepository>(
        Services.ProductsRepository
      ).editProductAttribute({
        id: attribute.id,
        color: colorId,
        count: form.getFieldValue("count"),
        price: form.getFieldValue("price"),
        size: form.getFieldValue("size"),
        sizeDescription: form.getFieldValue("sizeDescription"),
        offPrice: form.getFieldValue("offPrice"),
      });
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success("ویژگی محصول با موفقیت ویرایش شد");
          onClose(true);
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      visible={visible}
      confirmLoading={isLoading}
      onCancel={() => onClose(false)}
      onOk={submit}
      bodyStyle={{ paddingBottom: 0 }}
      destroyOnClose
    >
      <Form form={form}>
        <Item
          name="size"
          label={I18n.product.size}
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input name="size" defaultValue={attribute?.size} />
        </Item>
        <Item
          name="sizeDescription"
          label={I18n.product.sizeDescription}
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input
            name="sizeDescription"
            defaultValue={attribute?.sizeDescription}
          />
        </Item>
        <Item name="color" label={I18n.product.color} required>
          <Select
            aria-required
            onChange={(value) => setColorId(value.toString())}
            defaultValue={attribute?.color.id}
          >
            {colors.map((color) => {
              return (
                <Select.Option key={color.id} value={color.id}>
                  <Row align="middle">
                    <span
                      style={{
                        backgroundColor: color.color,
                        width: 24,
                        height: 24,
                        marginLeft: 16,
                      }}
                    >
                      {" "}
                    </span>
                    <Typography.Text>{color.title}</Typography.Text>
                  </Row>
                </Select.Option>
              );
            })}
          </Select>
        </Item>
        <Item
          name="price"
          label={I18n.product.price}
          required
          rules={[
            {
              required: true,
              validateTrigger: "onSubmit",
              type: "integer",
            },
          ]}
        >
          <Input
            name="price"
            defaultValue={attribute?.price}
            onChange={(event) => {
              form.setFields([
                { name: "price", value: parseInt(event.target.value) },
              ]);
            }}
          />
        </Item>
        <Item
          name="offPrice"
          label="قیمت تخفیف"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "integer" },
          ]}
        >
          <Input
            name="offPrice"
            defaultValue={attribute?.offPrice ? attribute?.offPrice : 0}
            onChange={(event) => {
              form.setFields([
                { name: "offPrice", value: parseInt(event.target.value) },
              ]);
            }}
          />
        </Item>
        <Item
          name="count"
          label={I18n.product.count}
          required
          rules={[
            {
              required: true,
              validateTrigger: "onSubmit",
              type: "integer",
            },
          ]}
        >
          <Input
            name="count"
            defaultValue={attribute?.count}
            onChange={(event) => {
              form.setFields([
                { name: "count", value: parseInt(event.target.value) },
              ]);
            }}
          />
        </Item>
      </Form>
    </Modal>
  );
};

export default EditAttributeModal;
